<template>
  <div>
    <h6 class="text-uppercase text-muted font-weight-bold mb-3">
      <i class="fas fa-history mr-1"></i> Payment History
    </h6>

    <div v-if="loading" class="text-center py-3 text-muted">
      <i class="fas fa-spinner fa-spin"></i>
    </div>

    <p v-else-if="invoices.length === 0" class="text-muted small mb-0">
      No payment history found.
    </p>

    <div v-else class="table-responsive">
      <table class="table table-sm table-borderless mb-0">
        <thead class="thead-light">
          <tr>
            <th class="text-uppercase text-muted small font-weight-bold border-0">Date</th>
            <th class="text-uppercase text-muted small font-weight-bold border-0">Description</th>
            <th class="text-uppercase text-muted small font-weight-bold border-0">Amount</th>
            <th class="text-uppercase text-muted small font-weight-bold border-0">Status</th>
            <th class="border-0"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(inv, i) in invoices" :key="i">
            <td class="text-nowrap align-middle small">{{ inv.date }}</td>
            <td class="align-middle small">{{ inv.description || '—' }}</td>
            <td class="text-nowrap align-middle small font-weight-bold">{{ inv.amount }}</td>
            <td class="align-middle">
              <span
                class="badge"
                :class="{
                  'badge-success': inv.status === 'paid',
                  'badge-warning': inv.status === 'open',
                  'badge-secondary': inv.status === 'void' || inv.status === 'uncollectible'
                }"
              >{{ inv.status }}</span>
            </td>
            <td class="text-nowrap align-middle">
              <a v-if="inv.invoice_pdf" :href="inv.invoice_pdf" target="_blank" class="text-warning mr-2" title="Download PDF">
                <i class="fas fa-file-pdf"></i>
              </a>
              <a v-if="inv.hosted_invoice_url" :href="inv.hosted_invoice_url" target="_blank" class="text-warning" title="View Invoice">
                <i class="fas fa-external-link-alt"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from '@/axios';

export default {
  name: 'PaymentHistory',
  data() {
    return {
      invoices: [],
      loading: false,
    };
  },
  methods: {
    fetch() {
      this.loading = true;
      axios({
        url: 'payments/paymentHistoryGet',
      })
        .then(res => {
          if (res.data.status === 1) {
            this.invoices = res.data.result.invoices;
          }
        })
        .catch(() => {})
        .finally(() => { this.loading = false; });
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>